export default {"src":"/_next/static/media/coding.ea4ce9eb.svg","height":78,"width":132};